import React, { useEffect, useState } from 'react';
import Loader from './components/loader/Loader';
import { Cookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
//import { dev } from "./features/network/ApiCall";
import swal from 'sweetalert';

function Middleware() {
  const cookies = new Cookies();
  const history = useHistory();
  const endpoint = localStorage.getItem('endpoint');
  // useEffect(() => {
  //   var setCookes = cookies.get("apiResponse");
  //   localStorage.setItem("userDetails", JSON.stringify(setCookes));
  //   console.log(setCookes);
  //   if (setCookes !== undefined) {
  //     history.push("/home");
  //   } else {
  //     history.push("/");
  //   }
  // }, []);

  useEffect(() => {
    async function sendRequest() {
      var axios = require('axios');
      var config = {
        method: 'get',
        url: `${process.env.REACT_APP_BASE_URL}/users/getProfileData`,
        headers: {
          'Content-Type': 'application/json'
        }
      };
      axios(config)
        .then(function (response: any) {
          // console.log(JSON.stringify(response));
          if (response.data.data !== null) {
            localStorage.setItem(
              'userDetails',
              JSON.stringify(response?.data?.data)
            );
            localStorage.setItem('isSSO', JSON.stringify(true));
            localStorage.setItem('isSession', JSON.stringify(true));
            window.location.href = !!endpoint ? endpoint : '/home';
            localStorage.removeItem('endpoint');
          } else {
            history.push('/');
          }
        })
        .catch(function (error: any) {
          console.log(error);
          // swal(error.data.error, "", "error");
          if (error.response.status === 401) {
            window.location.href = '/home';
          }
          return error;
        });
    }

    setTimeout(() => {
      sendRequest();
    }, 5000);
  }, []);

  return (
    <>
      <Loader />
    </>
  );
}

export default Middleware;
